import React from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Calendar, Wrench, GraduationCap, Heart, MapPin, Mail } from 'lucide-react';

const Home = () => {
  const events = [
    {
      title: "Rally del Lejano Oeste (RLO)",
      description: "Evento reconocido con más de una década de vigencia",
      icon: Calendar
    },
    {
      title: "500 Millas Mercedinas",
      description: "Competencia tradicional de la región",
      icon: Calendar
    },
    {
      title: "Almuerzo Popular Anual",
      description: "Con subasta de restauraciones y premios",
      icon: Calendar
    }
  ];

  const partners = [
    { 
      name: "JC SILICOM LAN", 
      logo: "https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/7mqerl5b_Captura%20de%20pantalla%202026-04-09%20a%20la%28s%29%2015.33.54.png",
      darkBg: false
    },
    { 
      name: "R Group", 
      logo: "https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/uqx7hytc_WhatsApp%20Image%202026-04-04%20at%2011.50.14.jpeg",
      darkBg: false
    },
    { 
      name: "BIG TRAIL ARG", 
      logo: "https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/725d5mbk_Captura%20de%20pantalla%202026-04-09%20a%20la%28s%29%2014.19.11.png",
      darkBg: false
    },
    { 
      name: "HERO GRAPHIX", 
      logo: "https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/7uayls7w_Captura%20de%20pantalla%202026-04-09%20a%20la%28s%29%2014.19.32.png",
      darkBg: false
    },
    { 
      name: "GRUPO HERMIDA", 
      logo: "https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/9jsqatnl_Captura%20de%20pantalla%202026-04-09%20a%20la%28s%29%2014.20.01.png",
      darkBg: false
    },
    { 
      name: "Tu empresa aquí", 
      logo: "",
      darkBg: false
    }
  ];

  const museums = [
    {
      title: "Museo de Motocicletas",
      description: "Colección única de motocicletas antiguas que cuentan la historia del motociclismo argentino y mundial",
      image: "https://customer-assets-wrfwihn1.emergentagent.net/job_moto-craft-academy/artifacts/qzzg2yyh_WhatsApp%20Image%202026-07-30%20at%2012.40.01.jpeg"
    },
    {
      title: "Museo de la Bicicleta",
      description: "El museo de bicicleta es el reconocimiento al primer vehículo particular y antecesor de la Motocicleta y lleva el nombre de 'Claudio Canaglia'",
      image: "https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/vzotma8c_WhatsApp%20Image%202026-04-10%20at%2022.27.38.jpeg"
    }
  ];

  return (
    <div className="min-h-screen bg-page">
      {/* Header/Navigation */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-page/95 backdrop-blur-sm border-b border-border-medium">
        <nav className="container mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/1pn1ueed_WhatsApp%20Image%202026-04-10%20at%2010.36.49.jpeg" 
                alt="Fundación Ruedas"
                className="h-16 w-auto"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#inicio" className="nav-link">Inicio</a>
              <a href="#proyecto" className="nav-link">Proyecto</a>
              <a href="#museos" className="nav-link">Museos</a>
              <a href="#escuela" className="nav-link">Escuela</a>
              <a href="#eventos" className="nav-link">Eventos</a>
              <a href="#colaboradores" className="nav-link">Colaboradores</a>
              <a href="#contacto" className="nav-link">Contacto</a>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="inicio" className="hero-section">
        <div className="hero-background">
          {/* YouTube Video Background */}
          <iframe
            className="hero-video"
            src="https://www.youtube.com/embed/D9Yovd0qIeg?autoplay=1&mute=1&loop=1&playlist=D9Yovd0qIeg&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
            title="Fundación Ruedas Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '100vw',
              height: '100vh',
              transform: 'translate(-50%, -50%)',
              objectFit: 'cover',
              pointerEvents: 'none',
              minWidth: '100%',
              minHeight: '100%'
            }}
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="container mx-auto px-8">
          <div className="hero-content">
            <h1 className="hero-title">
              PRESERVANDO LA HISTORIA SOBRE RUEDAS
            </h1>
            <p className="body-large mt-8 mb-16 max-w-2xl">
              Museo, escuela de restauración y centro cultural dedicado a la conservación de motocicletas y bicicletas antiguas
            </p>
            <div className="flex flex-wrap gap-4 mt-12">
              <a href="#proyecto">
                <Button className="btn-primary">
                  CONOCER MÁS
                </Button>
              </a>
              <a href="#contacto">
                <Button className="btn-secondary">
                  CONTACTAR
                </Button>
              </a>
              <a 
                href="https://www.youtube.com/watch?v=D9Yovd0qIeg" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 rounded-lg transition-all duration-300"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z"/>
                </svg>
                <span className="font-medium">VER VIDEO COMPLETO</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="proyecto" className="py-24 bg-card">
        <div className="container mx-auto px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="heading-2 text-primary mb-8">NUESTRO PROYECTO</h2>
            <div className="space-y-6">
              <p className="body-medium text-secondary">
                Fundación Ruedas es un proyecto integral que combina la preservación del patrimonio automotor con educación, desarrollo comunitario y turismo cultural.
              </p>
              <p className="body-medium text-secondary">
                Ubicados en Tomás Jofré, Buenos Aires, sobre la Ruta Nacional 5 km 85.5 y Ruta Provincial 42, estamos creando un espacio único que incluye museos de motocicletas y bicicletas, una escuela de restauración, espacios comunitarios y servicios de cicloturismo.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <Card className="p-6 bg-bg-page border-border-medium hover:border-primary transition-all">
                <Wrench className="w-12 h-12 text-primary mb-4" />
                <h3 className="heading-5 text-primary mb-3">Restauración</h3>
                <p className="body-small">
                  Preservación y restauración de vehículos históricos con técnicas tradicionales y modernas
                </p>
              </Card>
              <Card className="p-6 bg-bg-page border-border-medium hover:border-primary transition-all">
                <GraduationCap className="w-12 h-12 text-primary mb-4" />
                <h3 className="heading-5 text-primary mb-3">Educación</h3>
                <p className="body-small">
                  Formación de jóvenes mecánicos y restauradores creando oportunidades laborales
                </p>
              </Card>
              <Card className="p-6 bg-bg-page border-border-medium hover:border-primary transition-all">
                <Heart className="w-12 h-12 text-primary mb-4" />
                <h3 className="heading-5 text-primary mb-3">Comunidad</h3>
                <p className="body-small">
                  Desarrollo local, inclusión social y enriquecimiento cultural de la región
                </p>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Museums Section */}
      <section id="museos" className="py-24 bg-page">
        <div className="container mx-auto px-8">
          <h2 className="heading-2 text-primary mb-12 text-center">NUESTROS MUSEOS</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {museums.map((museum, index) => (
              <div key={index} className="event-card">
                <div className="event-card-image">
                  <img 
                    src={museum.image}
                    alt={museum.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="event-card-content">
                  <div>
                    <h3 className="event-card-title">{museum.title}</h3>
                    <p className="body-small text-secondary mt-4">
                      {museum.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Restoration School Section */}
      <section id="escuela" className="py-24 bg-card">
        <div className="container mx-auto px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div>
              <h2 className="heading-2 text-primary mb-6">ESCUELA DE RESTAURACIÓN</h2>
              <p className="body-medium text-secondary mb-6">
                La Escuela de Restauración Ruedas forma mecánicos y restauradores, creando oportunidades laborales para jóvenes de Mercedes y Luján.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small">Formación práctica en restauración de vehículos antiguos</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small">Desarrollo de oficios independientes y salidas laborales</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="body-small">Preservación de técnicas tradicionales de restauración</p>
                </li>
              </ul>
              <Button className="btn-primary mt-8">
                INFORMACIÓN DE INSCRIPCIÓN
              </Button>
            </div>
            <div className="relative h-96 md:h-full">
              <img 
                src="https://customer-assets-wrfwihn1.emergentagent.net/job_moto-craft-academy/artifacts/51dntyv2_WhatsApp%20Image%202026-07-30%20at%2012.40.01%20%281%29.jpeg"
                alt="Taller de Restauración"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section id="eventos" className="py-24 bg-page">
        <div className="container mx-auto px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="heading-2 text-primary mb-12 text-center">EVENTOS</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {events.map((event, index) => (
                <Card key={index} className="p-6 bg-card border-border-medium hover:bg-border-medium transition-all">
                  <event.icon className="w-10 h-10 text-primary mb-4" />
                  <h3 className="heading-6 text-primary mb-3">{event.title}</h3>
                  <p className="body-small text-secondary">{event.description}</p>
                </Card>
              ))}
            </div>
            <div className="mt-12 p-8 bg-card rounded-lg border border-border-medium">
              <h3 className="heading-5 text-primary mb-4">Otros Servicios</h3>
              <ul className="space-y-3">
                <li className="body-small text-secondary">• Salidas grupales en bicicletas por circuitos temáticos determinados con guías y asistencia</li>
                <li className="body-small text-secondary">• Alquiler de vehículos para cine y publicidad</li>
                <li className="body-small text-secondary">• Visitas educativas para instituciones</li>
                <li className="body-small text-secondary">• Cafetería temática y salas de reunión</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section id="colaboradores" className="py-24 bg-card">
        <div className="container mx-auto px-8">
          <div className="max-w-5xl mx-auto">
            <h2 className="heading-2 text-primary mb-12 text-center">COLABORADORES</h2>
            <p className="body-medium text-secondary text-center mb-12 max-w-2xl mx-auto">
              Agradecemos a nuestras empresas colaboradoras que hacen posible este proyecto de preservación cultural y desarrollo comunitario.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {partners.map((partner, index) => (
                <div 
                  key={index}
                  className={`flex items-center justify-center p-8 rounded-lg border-2 transition-all min-h-48 ${
                    partner.logo 
                      ? partner.darkBg 
                        ? 'bg-black border-border-strong hover:border-primary' 
                        : 'bg-white border-border-medium hover:border-primary'
                      : 'bg-bg-light border-dashed border-border-medium hover:border-primary'
                  }`}
                >
                  {partner.logo ? (
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="w-full h-auto max-h-32 md:max-h-28 object-contain"
                    />
                  ) : (
                    <p className="caption text-muted text-center">{partner.name}</p>
                  )}
                </div>
              ))}
            </div>
            <div className="mt-12 text-center">
              <Button className="btn-primary">
                CONVERTIRSE EN COLABORADOR
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-24 bg-page">
        <div className="container mx-auto px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="heading-2 text-primary mb-12 text-center">CONTACTO</h2>
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h3 className="heading-5 text-primary mb-6">Ubicación</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <MapPin className="w-6 h-6 text-primary mr-3 flex-shrink-0 mt-1" />
                    <div>
                      <p className="body-small text-secondary">
                        Ruta Nacional 5 km 85.5 y Ruta Provincial 42
                      </p>
                      <p className="body-small text-secondary">
                        Entrada a Tomás Jofré, Buenos Aires
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <Mail className="w-6 h-6 text-primary mr-3 flex-shrink-0 mt-1" />
                    <p className="body-small text-secondary">info@fundacionruedas.org</p>
                  </div>
                </div>
                <div className="mt-8">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/3fgr7b46_mapa%20vista%20aerea.png"
                    alt="Ubicación Fundación Ruedas"
                    className="w-full rounded-lg border border-border-medium"
                  />
                </div>
                <div className="mt-6">
                  <h4 className="heading-6 text-primary mb-4">Redes Sociales</h4>
                  <div className="flex space-x-4">
                    <a href="#" className="text-primary hover:text-brand-hover transition-colors">
                      Facebook
                    </a>
                    <a 
                      href="https://www.instagram.com/fundacionruedas/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:text-brand-hover transition-colors"
                    >
                      Instagram
                    </a>
                    <a href="#" className="text-primary hover:text-brand-hover transition-colors">
                      YouTube
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="heading-5 text-primary mb-6">Datos Legales</h3>
                <div className="space-y-3">
                  <p className="body-small text-secondary">
                    <strong className="text-primary">Razón Social:</strong><br />
                    Fundación Museo de Motocicletas y Bicicletas de Buenos Aires
                  </p>
                  <p className="body-small text-secondary">
                    <strong className="text-primary">CUIT:</strong> 30-71912128-0
                  </p>
                  <p className="body-small text-secondary">
                    <strong className="text-primary">Apertura Proyectada:</strong> 2027
                  </p>
                </div>
                <div className="mt-8 p-6 bg-card rounded-lg border border-border-medium">
                  <p className="body-small text-primary font-semibold mb-2">
                    "Preservar el pasado, construir un puente hacia el futuro"
                  </p>
                  <p className="caption text-secondary">
                    Fomentando el desarrollo local, la inclusión social y el enriquecimiento cultural.
                  </p>
                </div>
                <div className="mt-8">
                  <h3 className="heading-5 text-primary mb-4">Instalaciones</h3>
                  <img 
                    src="https://customer-assets.emergentagent.com/job_moto-craft-academy/artifacts/2z7audd1_cafeteria.jpeg"
                    alt="Cafetería Temática"
                    className="w-full rounded-lg border border-border-medium"
                  />
                  <p className="caption text-secondary mt-3">
                    Cafetería temática y espacios de encuentro
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 bg-card border-t border-border-medium">
        <div className="container mx-auto px-8">
          <div className="text-center">
            <h3 className="heading-4 text-primary mb-4">FUNDACIÓN RUEDAS</h3>
            <p className="caption text-secondary mb-6">
              Preservación • Educación • Comunidad
            </p>
            <p className="caption text-muted">
              © 2025 Fundación Ruedas. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
